// Funciones de tracking GA4. Solo disparan si VITE_GA_MEASUREMENT_ID está definida
// y el script de gtag ya fue inyectado por useGoogleAnalytics.

function gtag(...args: unknown[]) {
  if (typeof window.gtag !== 'function') return
  window.gtag(...args)
}

interface GaProducto {
  id: string
  nombre: string
  precio: number
  precio_oferta: number | null
  categoria: string | null
}

interface GaCartItem {
  producto: GaProducto
  cantidad: number
}

function toGaItem(producto: GaProducto, cantidad: number) {
  const price = producto.precio_oferta ?? producto.precio
  return {
    item_id:       producto.id,
    item_name:     producto.nombre,
    item_category: producto.categoria ?? undefined,
    price,
    quantity:      cantidad,
  }
}

export function trackViewItem(product: GaProducto) {
  const price = product.precio_oferta ?? product.precio
  gtag('event', 'view_item', {
    currency: 'UYU',
    value: price,
    items: [toGaItem(product, 1)],
  })
}

export function trackAddToCart(product: GaProducto, cantidad: number) {
  const price = product.precio_oferta ?? product.precio
  gtag('event', 'add_to_cart', {
    currency: 'UYU',
    value: price * cantidad,
    items: [toGaItem(product, cantidad)],
  })
}

export function trackViewCart(items: GaCartItem[], totalPrice: number) {
  gtag('event', 'view_cart', {
    currency: 'UYU',
    value: totalPrice,
    items: items.map(i => toGaItem(i.producto, i.cantidad)),
  })
}

export function trackBeginCheckout(items: GaCartItem[], totalPrice: number) {
  gtag('event', 'begin_checkout', {
    currency: 'UYU',
    value: totalPrice,
    items: items.map(i => toGaItem(i.producto, i.cantidad)),
  })
}

export function trackAddShippingInfo(items: GaCartItem[], totalValue: number, shippingTier: string) {
  gtag('event', 'add_shipping_info', {
    currency: 'UYU',
    value: totalValue,
    shipping_tier: shippingTier,
    items: items.map(i => toGaItem(i.producto, i.cantidad)),
  })
}

export function trackGenerateLead(origen: string, refId: string) {
  gtag('event', 'generate_lead', {
    lead_source: origen,
    ref: refId,
  })
}

export function trackPurchase(pedido: {
  id: string
  numero: number
  total: number
  metodo_entrega: string
  zona_retiro: string | null
  pedido_items: Array<{
    id: string
    nombre_producto: string
    precio_unitario: number
    cantidad: number
  }>
}) {
  gtag('event', 'purchase', {
    transaction_id: String(pedido.numero).padStart(3, '0'),
    value:          pedido.total,
    currency:       'UYU',
    shipping_tier:  pedido.metodo_entrega,
    zona_retiro:    pedido.zona_retiro ?? undefined,
    items: pedido.pedido_items.map(item => ({
      item_id:   item.id,
      item_name: item.nombre_producto,
      price:     item.precio_unitario,
      quantity:  item.cantidad,
    })),
  })
}
